// // src/context/UserContext.js
// import React, { createContext, useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
// import Cookies from "js-cookie";
// export const UserContext = createContext();

// const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

// export const UserProvider = ({ children }) => {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);
//   const [expiry, setExpiry] = useState(null);
//   const [isInitialized, setIsInitialized] = useState(false);

//   // 🔹 Sidebar global state
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const toggleSidebar = () => setSidebarOpen((prev) => !prev);
//   const closeSidebar = () => setSidebarOpen(false);
//   const openSidebar = () => setSidebarOpen(true);

//   // Load session
//   useEffect(() => {
//     try {
//       const savedUser = JSON.parse(localStorage.getItem("user"));
//       const savedExpiry = parseInt(localStorage.getItem("sessionExpiry"), 10);

//       if (savedUser && savedExpiry && Date.now() < savedExpiry) {
//         setUser(savedUser);
//         setExpiry(savedExpiry);
//       }
//     } catch (err) {
//       console.error("Session load error:", err);
//     } finally {
//       setIsInitialized(true);
//     }
//   }, []);

//   // Auto logout timer
//   useEffect(() => {
//     if (!isInitialized || !expiry) return;
//     const remainingTime = expiry - Date.now();
//     if (remainingTime <= 0) {
//       handleLogout(false);
//       return;
//     }
//     const timer = setTimeout(() => handleLogout(true), remainingTime);
//     return () => clearTimeout(timer);
//   }, [expiry, isInitialized]);

//   const handleLogout = (showAlert = true) => {
//     localStorage.removeItem("user");
//     localStorage.removeItem("sessionExpiry");
//     Cookies.remove("user");
//     Cookies.remove("token");
//     setUser(null);
//     setExpiry(null);
//     if (showAlert) {
//       Swal.fire({
//         title: "Logged Out",
//         text: "You have been logged out successfully.",
//         icon: "success",
//         timer: 2000,
//         showConfirmButton: false,
//       });
//     }
//     navigate("/");
//   };

//   const handleLogin = (userData) => {
//     const expireAt = Date.now() + SESSION_TIMEOUT;
//     localStorage.setItem("user", JSON.stringify(userData));
//     localStorage.setItem("sessionExpiry", expireAt);
//     setUser(userData);
//     setExpiry(expireAt);
//     navigate("/dashboard");
//   };

//   const refreshSession = () => {
//     if (!user) return;
//     const newExpiry = Date.now() + SESSION_TIMEOUT;
//     localStorage.setItem("sessionExpiry", newExpiry);
//     setExpiry(newExpiry);
//   };

//   useEffect(() => {
//     const events = ["mousemove", "keydown"];
//     events.forEach((ev) => window.addEventListener(ev, refreshSession));
//     return () => events.forEach((ev) => window.removeEventListener(ev, refreshSession));
//   }, [user]);

//   if (!isInitialized) {
//     return (
//       <div className="flex items-center justify-center h-screen text-gray-500">
//         Checking session...
//       </div>
//     );
//   }

//   return (
//     <UserContext.Provider
//       value={{
//         user,
//         handleLogin,
//         handleLogout,
//         sidebarOpen,
//         toggleSidebar,
//         closeSidebar,
//         openSidebar,
//       }}
//     >
//       {children}
//     </UserContext.Provider>
//   );
// };




// src/context/UserContext.js
import React, { createContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Cookies from "js-cookie";

export const UserContext = createContext();

const SESSION_TIMEOUT = 30 * 60 * 1000; // 30 minutes

export const UserProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [expiry, setExpiry] = useState(null);
  const [isInitialized, setIsInitialized] = useState(false);

  /* --------------------------------------------------------
     🔹 GLOBAL SIDEBAR STATE (Desktop + Mobile)
  -------------------------------------------------------- */

  // Desktop Collapsed Sidebar
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const closeSidebar = () => setSidebarOpen(false);
  const openSidebar = () => setSidebarOpen(true);

  // Mobile Sidebar (Slide-In Drawer)
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const openMobileSidebar = () => setIsMobileSidebarOpen(true);
  const closeMobileSidebar = () => setIsMobileSidebarOpen(false);
  const toggleMobileSidebar = () => setIsMobileSidebarOpen((p) => !p);

  /* --------------------------------------------------------
     🔹 LOAD SESSION ON APP START
  -------------------------------------------------------- */
  useEffect(() => {
    try {
      const savedUser = JSON.parse(localStorage.getItem("user"));
      const savedExpiry = parseInt(localStorage.getItem("sessionExpiry"), 10);

      if (savedUser && savedExpiry && Date.now() < savedExpiry) {
        setUser(savedUser);
        setExpiry(savedExpiry);
      }
    } catch (err) {
      console.error("Session load error:", err);
    } finally {
      setIsInitialized(true);
    }
  }, []);

  /* --------------------------------------------------------
     🔹 AUTO LOGOUT WHEN SESSION EXPIRES
  -------------------------------------------------------- */
  useEffect(() => {
    if (!isInitialized || !expiry) return;

    const remaining = expiry - Date.now();
    if (remaining <= 0) {
      handleLogout(false);
      return;
    }

    const timer = setTimeout(() => handleLogout(true), remaining);
    return () => clearTimeout(timer);
  }, [expiry, isInitialized]);

  /* --------------------------------------------------------
     🔹 LOGOUT USER
  -------------------------------------------------------- */
  const handleLogout = (showAlert = true) => {
    localStorage.removeItem("user");
    localStorage.removeItem("sessionExpiry");
    Cookies.remove("user");
    Cookies.remove("token");

    setUser(null);
    setExpiry(null);

    if (showAlert) {
      Swal.fire({
        title: "Logged Out",
        text: "You have been logged out successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });
    }

    navigate("/");
  };

  /* --------------------------------------------------------
     🔹 LOGIN USER
  -------------------------------------------------------- */
  const handleLogin = (userData) => {
    const expireAt = Date.now() + SESSION_TIMEOUT;

    localStorage.setItem("user", JSON.stringify(userData));
    localStorage.setItem("sessionExpiry", expireAt);

    setUser(userData);
    setExpiry(expireAt);

    navigate("/dashboard");
  };

  /* --------------------------------------------------------
     🔹 REFRESH SESSION ON USER ACTIVITY
  -------------------------------------------------------- */
  const refreshSession = () => {
    if (!user) return;
    const newExpiry = Date.now() + SESSION_TIMEOUT;
    localStorage.setItem("sessionExpiry", newExpiry);
    setExpiry(newExpiry);
  };

  useEffect(() => {
    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((ev) => window.addEventListener(ev, refreshSession));
    return () =>
      events.forEach((ev) => window.removeEventListener(ev, refreshSession));
  }, [user]);

  /* --------------------------------------------------------
     🔹 LOADING SCREEN WHILE CHECKING SESSION
  -------------------------------------------------------- */
  if (!isInitialized) {
    return (
      <div className="flex items-center justify-center h-screen text-gray-500">
        Checking session...
      </div>
    );
  }

  /* --------------------------------------------------------
     🔹 PROVIDE VALUES TO APP
  -------------------------------------------------------- */
  return (
    <UserContext.Provider
      value={{
        user,
        handleLogin,
        handleLogout,

        /* Sidebar Global State */
        sidebarOpen,
        toggleSidebar,
        openSidebar,
        closeSidebar,

        /* Mobile Sidebar State */
        isMobileSidebarOpen,
        openMobileSidebar,
        closeMobileSidebar,
        toggleMobileSidebar,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
